import { Typography, Flex } from "antd";
import { InputBox } from "Components/TextInputBox";
import { TitleCardsList } from "Components/SelectableCard/Title";
import { SingleSelectDropdown } from "Components/SingleSelectDropdown";

const awardRecognitionLevels = [
  {
    title: "Internal",
  },
  {
    title: "State",
  },
  {
    title: "National",
  },
  {
    title: "International",
  },
];

const options = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const AwardsAndRecognition = ({
  receivedAwards,
  setReceiveAwards,
  awardName,
  setAwardName,
  level,
  setLevel,
}) => {
  const { Title } = Typography;
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px", fontWeight: "500", textAlign: "left" }}>
        Awards & Recognition
      </Title>
      <SingleSelectDropdown
        options={options}
        placeholder="Did you receive awards?"
        loading={false}
        onChange={setReceiveAwards}
        value={receivedAwards ? "Yes" : "No"}
      />
      {receivedAwards && (
        <>
          <Title
            style={{ fontSize: "18px", marginTop: "24px", fontWeight: "500" }}
          >
            Award Name
          </Title>
          <InputBox
            placeholder="Sport"
            value={awardName}
            onChange={setAwardName}
            required={true}
            widthSize={"large"}
            heightSize="small"
          />
          <Title
            style={{ fontSize: "18px", marginTop: "24px", fontWeight: "500" }}
          >
            Level
          </Title>
          <Flex wrap>
            <TitleCardsList
              options={awardRecognitionLevels}
              selectedCard={level}
              setSelectedCard={setLevel}
            />
          </Flex>
        </>
      )}
    </Flex>
  );
};
